<script>
export default {
  name: 'DynamicYieldPageContext',
  template: '<!-- SSR placeholder -->',
};
</script>
